export const getTypeTabTitle = (type, brandName, isAccordionTitle) => {
  switch (type) {
    case 'collection': {
      return isAccordionTitle && brandName ? `Shop This Collection from ${brandName}` : 'More from This Brand';
    }
    case 'accessories': {
      return isAccordionTitle ? 'Get Everything You Need' : 'Shop Accessories';
    }
    case 'coordinatingItems': {
      return isAccordionTitle ? 'Coordinating Items' : 'Shop Coordinating Items';
    }
    default: {
      return type;
    }
  }
};
